class BpSlider {

	constructor(sel) {
		// view
		this.components = document.querySelectorAll(sel);
		this.sel = sel;
		this.sliders = {};
		this.events = {};
		this.initEvents = globalThis?.BP_SLIDER?.initEvents ?? [];

		if (this.components.length) {

			this.tryTillTrue(() => {
				if (typeof Splide == "undefined") return false;

				this.init();
				return true
			}, { tag: "Init Bp Slider" })

		}
	}

	onSlideInit = (cb) => this.initEvents.push(cb);

	updateOverlapContent = async (nextSlide, _slider, overlapContent) => {
		const template = nextSlide.querySelector('template.slide-content');

		if (template) {
			overlapContent.classList.toggle('loading', true);
			await this.sleep(500);
			const content = template.content.cloneNode(true);
			overlapContent.innerHTML = '';
			overlapContent.appendChild(content);
			overlapContent.classList.toggle('loading', false);
		}

	}
	initPagination = (comp, _slider) => {
		const pagination = comp.querySelector('.splide__pagination');

		if (pagination) {

			const template = comp.querySelector('template.pagination-info');

			const content = template.content.cloneNode(true)

			const _container = document.createElement('div');
			_container.appendChild(content); // mete el fragmento en un div temporal
			const html = _container.innerHTML;



			if (template) {
				_slider.on('pagination:mounted', (data) => {
					// You can add your class to the UL element
					data.list.classList.add('splide__pagination--custom');



					// `items` contains all dot items
					data.items.forEach(function (item, index) {
						item.button.innerHTML = html;
						const text = _slider.Components.Slides.getAt(index)?.slide.dataset.label;
						item.button.querySelector('.slide-page-label').innerText = text;
					});
				});
			}
		}
	}

	tryTillTrue = async (conditional, { maxTries = 300, delay = 20, tag = "TryTillTrueCb" } = {}) => {
		let tries = 0;
		while (tries < maxTries) {
			const result = await conditional();
			if (result) return result;
			await new Promise(res => setTimeout(res, delay));
			tries++;
		}
		console.warn(`Max Tries on ${tag}`)
		return null;
	}
	init() {
		this.components.forEach((comp, i) => {
			let slider = comp.querySelector('.splide');
			const splide = new Splide(slider);

			slider.id = 'slide-' + i;
			this.events[slider.id] = [];
			this.sliders[slider.id] = splide;

			this.initEvents.forEach(cb => cb(slider.id, splide));


			const overlapContent = comp.querySelector('.splide > .slide-overlap');


			const counter = comp.querySelector('.splide__counter');
			const arrows = comp.querySelector('.splide__arrows');



			this.initPagination(comp, splide);



			if (counter) {
				const count = comp.querySelectorAll('.splide__slide').length;
				comp.querySelector('#length').innerHTML = count < 10 ? `0${count}` : count;
				if (count === 1) {
					counter.classList.add('hide');
					if (arrows) {
						arrows.classList.add('hide');
					}
				}
			}



			splide.on('move', async (i, prev) => {
				splide.root.dataset.index = i;
				splide.root.dataset.status = 'move';
				const nextSlide = splide.Components.Slides.getAt(i).slide;

				if (counter) counter.querySelector('#count').innerHTML = i < 10 ? `0${i + 1}` : i;

				requestAnimationFrame(() => {
					nextSlide.classList.toggle('focused', true);
					splide.Components.Slides.getAt(prev).slide.classList.toggle('focused', false);
				})

				if (overlapContent) this.updateOverlapContent(nextSlide, splide, overlapContent, prev);
				await this.sleep(500)

			})

			splide.on('moved', async (i, prev) => splide.root.dataset.status = 'moved')

			splide.on('ready', () => {
				comp.querySelector('.splide__slide').classList.toggle('focused', true);
				const nextSlide = splide.Components.Slides.getAt(0).slide;
				if (overlapContent) this.updateOverlapContent(nextSlide, splide, overlapContent);

				if (counter) counter.querySelector('#count').innerHTML = `0${i + 1}`;

				setTimeout(() => { splide.go(1) }, 20);

				setTimeout(() => {
					splide.go(0)
				}, 250);
			})

			window.requestAnimationFrame(() => splide.mount())

		})

	}
	sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

}

document.addEventListener('DOMContentLoaded', e => globalThis.BP_SLIDER = new BpSlider('.bp-slider'))
